






import { Component, Vue } from "vue-property-decorator";
import { DaXinKeTangDataType } from "../../service/type";
import { getInfoOfdxkt } from "../../service/index";
const win: any = window;
@Component({})
export default class CommonQuestion extends Vue {
  //兜底跳转链接
  private jumpUrl =
    "//mams.10jqka.com.cn/new/server/html/62295.html?enter_sign=prd_xtzkhdxktqa";
  //兜底文案
  private wenan = "了解打新常见问题";

  private async created() {
    const res: null | DaXinKeTangDataType = await getInfoOfdxkt();
    if (res) {
      const data = res.daxinketang.find((val) => {
        //3551是区分多条数据项的标识，在接口中表示常见问题对应的数据项
        return String(val.data_id) === "3551";
      });
      this.jumpUrl = data!.url.url;
      this.wenan = data!.wenan;
    }
  }

  //跳转常见问题
  private jump() {
    if (this.jumpUrl) {
      win.F10Utils.jumpToLink({
        url: this.jumpUrl,
      });
    }
  }
}
